import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Avatar3D } from "@/components/Avatar3D";
import { InteractionFX, playInteractionSound } from "@/components/InteractionFX";

/** Overlay wrapper: polls avatar config (+ her mood) and gesture/interaction events; fires idle wiggles on its own. */
export default function OverlayAvatar() {
  const [cfg, setCfg] = useState(null);
  const [fx, setFx] = useState(null);
  const cfgRef = useRef(null); const gesture = useRef(null); const headRef = useRef(null); const after = useRef(new Date().toISOString()); const lastIdle = useRef(Date.now());
  useEffect(() => {
    const loadCfg = async () => { try { const c = (await api.get("/avatar/config")).data; cfgRef.current = c; setCfg(c); } catch (e) {} };
    const poll = async () => {
      try {
        const evs = (await api.get(`/avatar/events?after=${encodeURIComponent(after.current)}`)).data;
        for (const ev of evs) {
          after.current = ev.created_at; gesture.current = { name: ev.gesture, t0: performance.now() + (ev.interaction ? 600 : 0) }; lastIdle.current = Date.now();
          if (ev.interaction) { const id = ev.id; playInteractionSound(cfgRef.current?.interactions?.[ev.interaction]?.sound_url); setFx({ id, kind: ev.interaction, user: ev.user }); setTimeout(() => setFx((f) => (f?.id === id ? null : f)), ev.interaction === "headpat" ? 2800 : 3400); }
        }
      } catch (e) {}
    };
    loadCfg(); poll(); const a = setInterval(loadCfg, 5000); const b = setInterval(poll, 1500); return () => { clearInterval(a); clearInterval(b); };
  }, []);
  useEffect(() => {
    const t = setInterval(() => {
      const mins = cfg?.idle_minutes ?? 3; if (!mins || gesture.current) return;
      if (Date.now() - lastIdle.current > mins * 60000 && Math.random() < 0.3) { const picks = ["wiggle", "nod", "peek", "wave", "dance"]; gesture.current = { name: picks[Math.floor(Math.random() * picks.length)], t0: performance.now() }; lastIdle.current = Date.now(); }
    }, 5000);
    return () => clearInterval(t);
  }, [cfg?.idle_minutes]);
  if (!cfg || !cfg.enabled || !cfg.model_url) return null;
  const width = 420, height = cfg.framing === "face" ? 420 : cfg.framing === "half" ? 500 : 560;
  return (
    <div className="relative" style={{ width, height }}>
      <Avatar3D modelUrl={cfg.model_url} cfg={cfg} emotion={fx ? "happy" : cfg.emotion} gestureRef={gesture} headRef={headRef} width={width} height={height} />
      <InteractionFX fx={fx} framing={cfg.framing} width={width} height={height} headRef={headRef} images={fx ? cfg.interactions?.[fx.kind] : undefined} />
    </div>
  );
}
